/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUsersResponseItemDivider
 */
export interface GetUsersResponseItemDivider {
    /**
     * 
     * @type {boolean}
     * @memberof GetUsersResponseItemDivider
     */
    isdivider: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUsersResponseItemDivider
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof GetUsersResponseItemDivider
     */
    uid: string;
}

export function GetUsersResponseItemDividerFromJSON(json: any): GetUsersResponseItemDivider {
    return GetUsersResponseItemDividerFromJSONTyped(json, false);
}

export function GetUsersResponseItemDividerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUsersResponseItemDivider {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isdivider': json['isdivider'],
        'label': json['label'],
        'uid': json['uid'],
    };
}

export function GetUsersResponseItemDividerToJSON(value?: GetUsersResponseItemDivider | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isdivider': value.isdivider,
        'label': value.label,
        'uid': value.uid,
    };
}


